{
    "Profile_Drivers.drivers": "FR: Drivers",
    "Profile_Drivers.driver": "FR: Driver {number}"
}
